export const FORMATS = [
  'pdf',
  'doc',
  'docx',
  'epub',
  'html',
  'md',
  'odp',
  'odt',
  'ods',
  'ppt',
  'pps',
  'ppsx',
  'pptx',
  'rtf',
  'mobi',
  'txt',
  'xls',
  'xlsx',
]
